import React, {Component} from 'react'
import ReactSelect from 'react-select'
import LinkWithTooltip from '../../tooltip';

class Fontstyle extends Component {

  onClickHandle(event){
    const { input: { value, onChange, name }, params } = this.props

    var fontstyle = event.target.dataset.fontstyle;

    let newValue = Object.assign({},value, {
      [fontstyle]: !value[fontstyle]
    })

    onChange(newValue);

  }

  logChange(val){
    const { input: { value, onChange, name } } = this.props

    let newValue = Object.assign({},value, {
      weight: val.value
    })

    onChange(newValue);

  }

  render(){
    const { input, params } = this.props

    var options = [
      { value: "", label: 'Default' },
      { value: 100, label: 'Thin' },
      { value: 200, label: 'Extra Light' },
      { value: 300, label: 'Light' },
      { value: 400, label: 'Normal' },
      { value: 500, label: 'Medium' },
      { value: 600, label: 'Semi Bold' },
      { value: 700, label: 'Bold' },
      { value: 800, label: 'Extra Bold' },
      { value: 900, label: 'Black' }
    ];

    let underlineActive = ((input.value !== undefined && input.value.underline)) ? 'active' : '';
    let italicActive = ((input.value !== undefined && input.value.italic)) ? 'active' : '';
    let uppercaseActive = ((input.value !== undefined && input.value.uppercase)) ? 'active' : '';

    return(
      <div className="sp-pagebuilder-form-group">
        <label>
          { params.title }
          {
            typeof params.desc != 'undefined' && params.desc != '' &&
            <LinkWithTooltip tooltip={params.desc} position="top" title={params.title}>
              <i className="fa fa-question-circle" />
            </LinkWithTooltip>
          }
        </label>

        <div className="sp-pagebuilder-fontstyle-options clearfix">
          <div className={ underlineActive }>
            <span onClick={ this.onClickHandle.bind(this) } data-fontstyle="underline" className="sp-pagebuilder-fontstyle-underline">U</span>
          </div>

          <div className={ italicActive }>
            <span onClick={ this.onClickHandle.bind(this) } data-fontstyle="italic" className="sp-pagebuilder-fontstyle-italic">I</span>
          </div>

          <div className={ uppercaseActive }>
            <span onClick={ this.onClickHandle.bind(this) } data-fontstyle="uppercase" className="sp-pagebuilder-fontstyle-uppercase">AA</span>
          </div>

          <div className="sp-pagebuilder-fontstyle-weight">
            <ReactSelect
              name="form-fontstyle-weight"
              value={ input.value.weight }
              options={ options }
              clearable = { false }
              onChange={ this.logChange.bind(this) }
            />
          </div>

        </div>
      </div>
    )
  }
}

export default Fontstyle;



// WEBPACK FOOTER //
// ./src/helpers/form/types/Fontstyle.js